import { c as _c } from "react/compiler-runtime";
import { Image, Maybe, TagStyle } from "common/types/graphql";
import { ContentSummaryProps, ContentSummaryVariant } from "common/components/ContentSummary";
import { ContentSummary } from "common/components/ContentSummary";
import { ImageAspectRatio } from "modules/editor/types";

/**
 * Custom URL Block will be rendered as a Content Summary in grid slots,
 * so their props interface are very similar to the Content Summary props.
 */
export interface CustomUrlBlockProps {
  title?: string;
  href?: string;
  imageAlt?: string;
  image?: Maybe<Partial<Image>>;
  tagStyle?: Maybe<TagStyle>;
  tagLabel?: Maybe<string>;
  variant?: ContentSummaryVariant;
  /**
   * Optional parameter to add custom classes to underlying content summary variants.
   */
  className?: string;
  desktopImageAspectRatio?: ImageAspectRatio;
  desktopImageCrop?: ImageAspectRatio;
}

/**
 * The Custom URL block will render as a Content Summary in grid slots, so we'll use the same
 * Content Summary component to render it while converting some of the props to match the
 * Content Summary props.
 */
export const CustomUrlBlock = props => {
  "use memo";

  const $ = _c(10);
  const {
    image,
    imageAlt,
    href,
    className: t0
  } = props;
  const className = t0 === undefined ? "" : t0;
  const appendedClassName = "custom-url-block " + className;
  let t1;
  if ($[0] !== appendedClassName) {
    t1 = appendedClassName.trim();
    $[0] = appendedClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = imageAlt || image?.alt;
  let t3;
  if ($[2] !== image || $[3] !== t2) {
    t3 = {
      ...image,
      alt: t2
    };
    $[2] = image;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== href || $[6] !== props || $[7] !== t1 || $[8] !== t3) {
    const contentSummaryProps = {
      ...props,
      url: href,
      anchorTarget: "_blank",
      className: t1,
      image: t3
    };
    t4 = <ContentSummary {...contentSummaryProps} />;
    $[5] = href;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};